export default {
      id: "ic_navbar_tickets-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_navbar_tickets-usage",
      toString: function () {
        return this.url;
      }
    }